import { type ConversationAction } from '@atlassian/rovo-conversation-actions';

/** A nudge declared by actionId. The action is resolved from viewPageRovoActions via actionsById. */
export type NudgeById = { actionId: string; enabled: boolean };

/** A nudge declared with the action object directly, as returned by a dedicated hook (e.g. useConvoStartersNudgeAction). */
export type NudgeByAction = { action: ConversationAction | null; enabled: boolean };

/** A nudge entry — either resolved by actionId (NudgeById) or provided directly (NudgeByAction). */
export type NudgeEntry = NudgeById | NudgeByAction;

/** Type guard — returns true when the entry is a NudgeByAction (has a direct action object). */
export const isNudgeByAction = (entry: NudgeEntry): entry is NudgeByAction => 'action' in entry;
